export const fieldLabels = {
    title: "Unit title",
    aounitReferenceNumber: "Organisation unit reference number",
    unitLevel: "Unit level",
    unitSubLevel: "Unit sub-level",
    unitCredit: "Credit value",
    unitGLH: "GLH",
    unitSectorSubjectArea: "Subject sector area",
    learningOutcomes: "Learning outcomes",
    unitEndDate:"Unit end date"

};